import { Component, OnInit, Input  } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { nullSafe } from 'src/app/utils';


@Component({
  selector: 'eos-immigration-requestcopydialog',
  templateUrl: './immigration-requestcopydialog.component.html'
})
export class ImmigrationRequestcopydialogComponent implements OnInit {
  
  @Input() noofcopies: number = 0;
  @Input() header = "No of Copies";
  @Input() message = "Enter no of requests to copy";
  constructor(public modal: NgbActiveModal) { }

  ngOnInit() {
  }
  isNumber() {
    if (nullSafe<number>(() => this.noofcopies) > 0 && nullSafe<number>(() => this.noofcopies)<=100) {
      return true;
    }
    return false;
  }
}
